import { useCallback, useEffect } from 'react';
import useRequestContext from '../context/requestContext';
import { getProfessions } from '../Services/httpCalls';

export default function useProfessions() {
  const { professions, setProfessions } = useRequestContext();

  const getProfessionsData = useCallback(async () => {
    const res = await getProfessions();

    if (res) {
      const mappedProofs = res.professions?.map((item) => ({
        id: item.id,
        label: item.description,
      }));
      setProfessions(mappedProofs);
    }
  }, [setProfessions]);

  useEffect(() => {
    if (professions.length > 0) return;

    getProfessionsData();
  }, []);

  return { professions };
}
